import { render, staticRenderFns } from "./TopicAnalysisCard.vue?vue&type=template&id=b4da049c&scoped=true"
import script from "./TopicAnalysisCard.vue?vue&type=script&lang=js"
export * from "./TopicAnalysisCard.vue?vue&type=script&lang=js"
import style0 from "./TopicAnalysisCard.vue?vue&type=style&index=0&id=b4da049c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4da049c",
  null
  
)

export default component.exports